export default {"src":"/_next/static/media/world.84df2416.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};